export default {
    "es": {
        "additionals": {
            "add": "Agregar Adicional",
            "edit": "Editar Adicional",
            "delete": "Eliminar Adicional",
            "not_find": "No se puede encontrar un adicional con este codigo.",
            "id": "Id",
            "project_name": "Nombre de Proyecto",
            "location": "Locación",
            "project_created_on": "Proyecto creado en",
            "project_created_by": "Proyecto creado por",
            "docs_date_recived": "Fecha de recepción de documentos",
            "created_at": "Creado en",
            "report_title": "Reporte de adicional"
        },
        "articles": {
            "add": "Agregar artículo",
            "edit": "Editar artículo",
            "delete": "Eliminar artículo",
            "not_find": "No se puede encontrar un artículo con este código.",
            "id": "Id",
            "category": "Artículo",
            "category_placeholder": "Ingrese el artículo",
            "type": "Tipo",
            "created_at": "Creado en",
            "report_title": "Reporte de Artículos"
        },
        "auth": {
            "failed": "Estas credenciales no coinciden con nuestros registros.",
            "throttle": "Demasiados intentos de inicio de sesión. Por favor intente de nuevo en :seconds segundos."
        },
        "change_orders": {
            "add": "Agregar Order de Cambio",
            "edit": "Editar Order de Cambio",
            "name": "Nombre",
            "status": "Estado",
            "type": "Type",
            "amount": "Monto",
            "created_by": "Creado Por",
            "date": "Fecha",
            "name_placeholder": "Ingresa el Nombre",
            "type_placeholder": "Ingresa el Type",
            "amount_placeholder": "Ingresa el Monto",
            "date_placeholder": "Ingresa la Fecha",
            "category_id": "Artículo",
            "category_id_placeholder": "Seleccione el artículo",
            "quantity": "Cantidad del alcance",
            "quantity_placeholder": "Ingrese la cantidad del alcance",
            "unit_measurement": "Unidad de medida del alcance",
            "unit_measurement_placeholder": "Ingrese la unidad de medida del alcance",
            "quantity2": "Cantidad",
            "quantity2_placeholder": "Ingrese la cantidad",
            "unit_measurement2": "Unidad de medida",
            "unit_measurement2_placeholder": "Ingrese la unidad de medida",
            "comments": "Comentarios",
            "comments_placeholder": "Ingrese los comentarios",
            "approve": "Aprobar",
            "cancel": "Cancelar"
        },
        "claims": {
            "add": "Agregar un problema de embarque",
            "edit": "Responder Problema de embarque",
            "delete": "Delete claim",
            "not_find": "Can not find a claim with this code.",
            "id": "Id",
            "claims": "Reportes de Problema",
            "claim": "Reportar un Problema",
            "date": "Fecha",
            "date_placeholder": "Ingrese la fecha del reporte",
            "question": "Pregunta",
            "question_placeholder": "Ingrese la Pregunta del reporte",
            "answer": "Respuesta",
            "answer_placeholder": "Ingrese la respuesta al reporte",
            "customer_id": "Creado por",
            "project_id": "Proyecto",
            "shipment_id": "Embarque",
            "already_answered": "Este claim ya fue contestado",
            "created_at": "Creado en",
            "report_title": "Reporte de claims"
        },
        "customers": {
            "add": "Agregar cliente",
            "edit": "Editar cliente",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un cliente con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del cliente",
            "contact": "Contacto",
            "contact_placeholder": "Ingresa el contacto del cliente",
            "address": "Dirección",
            "address_placeholder": "Ingresa la dirección del cliente",
            "state": "Estado",
            "state_placeholder": "Ingresa el estado",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el teléfono del cliente",
            "email": "Correo electrónico",
            "email_placeholder": "Ingresa el correo del cliente",
            "website": "Sitio Web",
            "website_placeholder": "Ingrese el sitio web del cliente",
            "view_payments": "View Payments",
            "created_at": "Creado en",
            "report_title": "Reporte de Clientes"
        },
        "employees": {
            "add": "Agregar empleado",
            "edit": "Editar empleado",
            "view": "Ver empleado",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un empleado con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del empleado",
            "contact": "Contacto",
            "contact_placeholder": "Ingresa el contacto del empleado",
            "address": "Dirección",
            "address_placeholder": "Ingresa la dirección del empleado",
            "state": "Estado",
            "state_placeholder": "Ingresa el estado",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el teléfono del empleado",
            "email": "Correo electrónico",
            "email_placeholder": "Ingresa el correo del empleado",
            "website": "Sitio Web",
            "website_placeholder": "Ingrese el sitio web del empleado",
            "view_payments": "Ver Pagos",
            "created_at": "Creado en",
            "report_title": "Reporte de Clientes"
        },
        "errors": {
            "fatal_error": "Se produjo un error fatal, póngase en contacto con nosotros.",
            "generic_error": "Ha ocurrido un error. Por favor intente de nuevo.",
            "unauthorized": "No autorizado.",
            "connection_error": "Error de conexión",
            "action_unauthorized": "No estas autorizado para realizar esta acción",
            "info": "Error."
        },
        "feedback": {
            "rate": "¿Como te parece este sistema?",
            "comment": "¿Cuéntanos cómo ha sido tu experiencia?",
            "contact_me": "Controlla puede comunicarse conmigo en relación con mis comentarios."
        },
        "field_used_drawings": {
            "add": "Agregar Field Used Drawing",
            "edit": "Editar Field Used Drawing",
            "name": "Nombre",
            "status": "Estado",
            "type": "Tipo",
            "amount": "Monto",
            "created_by": "Creado por",
            "date": "Fecha",
            "name_placeholder": "Ingrese el nombre",
            "type_placeholder": "Seleccione el tipo",
            "amount_placeholder": "Ingrese el monto",
            "date_placeholder": "Ingrese la fecha",
            "category": "Categoria",
            "category_placeholder": "Seleccione la categoria",
            "drawing_number": "Drawing number",
            "drawing_number_placeholder": "Ingrese el drawing number",
            "title": "Titulo",
            "title_placeholder": "Ingrese el titulo",
            "revision": "Revision",
            "revision_placeholder": "Ingrese la revision",
            "approve": "Aprobado",
            "cancel": "Cancelado"
        },
        "finisheds": {
            "add": "Agregar proyecto terminado ",
            "edit": "Editar proyecto en etapa final",
            "delete": "Eliminar proyecto terminado",
            "not_find": "No se puede encontrar un proyecto con este codigo",
            "id": "Id",
            "completion_date": "Fecha de Conclusión",
            "completion_date_placeholder": "Ingrese la fecha en que se completó el proyecto",
            "project_name": "Nombre de proyecto",
            "location": "Locación",
            "amount": "Monto",
            "currency": "Moneda",
            "project_created_on": "Proyecto creado en",
            "quotation_start_date": "Fecha de Inicio de Cotización",
            "delivery_deadline": "Fecha de entrega",
            "customer": "Cliente",
            "created_at": "Creado en",
            "report_title": "Reporte de Terminados"
        },
        "front": {
            "added_successfully": "Ha sido agregado con éxito.",
            "updated_successfully": "Ha sido actualizado con éxito.",
            "deleted_successfully": "Ha sido eliminado con éxito.",
            "imported_successfully": "Ha sido importado con éxito.",
            "reloaded_successfully": "Ha sido racargado con éxito.",
            "delete_modal": "Eliminar",
            "delete_confirmation": "¿Seguro que quieres eliminar la :model :attribute?",
            "delete_confirmation2": "¿Seguro que quieres eliminar el :model :attribute?",
            "action_confirmation": "¿Seguro que deseas :action esta :model?",
            "action_confirmation2": "¿Seguro que deseas :action este :model?",
            "cancel_modal": "Cancelar",
            "cancel_confirmation2": "¿Está seguro que desea cancelar este proyecto? Esta acción no se puede deshacer",
            "import_modal": "Importar :model desde un archivo CSV o Excel",
            "role": "Para Gestionar Permisos Seleccione el rol correcto",
            "role_validate": "Para administrar los permisos es necesario seleccionar el rol manual, si se selecciona otro rol se tomaran los permisos correspondientes a ese rol",
            "select_permissions": "Seleccione algún permiso",
            "select_permissions_text": "Seleccione algun permiso para guardar el usuario con rol manual o seleccione otro rol"
        },
        "gallery": {
            "add": "Agregar foto a la galeria",
            "edit": "Editar foto de la galeria",
            "delete": "Eliminar foto de la galeria",
            "not_find": "No se puede encontrar una foto con este codigo.",
            "id": "Id",
            "description": "Descripción",
            "description_placeholder": "Ingrese la descripcion de la foto",
            "date": "Fecha",
            "shipment_id": "Embarque",
            "shipment_id_placeholder": "Seleccione el embarque",
            "remision": "Tipo",
            "remision_placeholder": "Seleccione el Tipo",
            "created_at": "Created at",
            "report_title": "Reporte de galería"
        },
        "invoices": {
            "add": "Agregar Factura",
            "edit": "Editar Factura",
            "see": "Detalles de Factura",
            "delete": "Eliminar Factura",
            "not_find": "No se puede encontrar una factura con este codigo",
            "delete_payment_confirmation": "¿Seguro que quieres eliminar el pago?",
            "delete_invoice_confirmation": "¿Seguro que quieres eliminar la factura?",
            "folio": "Folio",
            "invoice_date": "Fecha de factura",
            "payments": "Pagos",
            "total": "total",
            "paidout": "Pagado",
            "remaining": "Restante",
            "amount": "Monto",
            "amount_placeholder": "Ingrese el monto del pago",
            "available_amount": "disponible a facturar",
            "exceeded_amount": "La cantidad debe ser menor o igual a: ",
            "type": "Tipo",
            "type_placeholder": "Ingrese el tipo de pago",
            "receipt": "Recivido",
            "folio_placeholder": "Ingrese el Folio",
            "balance": "Balance"
        },
        "login": {
            "email": "Correo electrónico",
            "password": "Contraseña",
            "keep_connected": "Recordarme",
            "forgot_password": "Restablecer",
            "login": "Iniciar sesión",
            "logout": "Cerrar sesión",
            "reset_password": "Restablecer la contraseña",
            "send_reset_link": "Enviar el enlace de reinicio",
            "password_confirmation": "Confirmación de contraseña",
            "still_having_trouble": "¿Sigues teniendo problemas para iniciar sesión?",
            "havent_account": "No tienes una cuenta?",
            "back_login": "Volver a Inicio de sesión",
            "register": "Crear cuenta",
            "welcome": "Bienvenido",
            "description": "Descripción"
        },
        "notifications": {
            "empty_title": "No hay notificaciones en este momento",
            "empty_msg": "Cuando tu equipo empiece a hacer cosas, mostraremos las notificaciones aquí.",
            "add_new_project": "Nuevo Projecto",
            "add_new_project_message": " ha sido agregado",
            "docs_recived": "Documentos Recividos",
            "docs_date_recived_message": " los documentos han sido recividos por cano",
            "quotation": "Nueva Cotización",
            "quotation_message": " se ha creado una nueva cotización",
            "revision_approved": "Revision Aprovada",
            "revision_approved_message": " una Revision ha sido aprovada",
            "quotation_file": "Nuevo Archivo de Cotización",
            "quotation_file_message": " un nuevo archivo de cotizacion ha sido subido",
            "project_assigned": "Proyecto asignado",
            "assigned_message": " ha sido asignado",
            "add_rfi": "Nuevo RFI",
            "add_rfi_message": " ha sido agregado",
            "update_rfi": "RFI Actualizado",
            "update_rfi_message": " ha sido actualizado",
            "pause_project": "Proyecto en Pausa",
            "pause_project_message": " ha sido actualizado",
            "updated_shipment": "Embarque Actualizado",
            "updated_shipment_message": " ha sido actualizado",
            "reply_date": "Nueva Fecha de Respuesta",
            "reply_date_message": " ha sido añadida",
            "delivery_deadline": "La entrega se acerca!",
            "delivery_deadline_message": " la fecha de entrega ha sido cambiada",
            "updated_scope": "Alzance Actualizado",
            "updated_scope_message": " ha sido actualizado",
            "add_claim": "Nuevo Reporte",
            "add_claim_message": " tiene un reporte nuevo",
            "claim_updated": "Reporte Contestado",
            "claim__updated_message": " tiene una nueva respuesta a un reporte",
            "add_new_additional": "Nuevo Adicional",
            "add_new_additional_message": " tiene un nuevo adicional",
            "add_new_payment": "Nuevo Pago",
            "add_new_payment_message": " tiene un pago nuevo",
            "delivery_date": "La entrega de la cotización se acerca!",
            "three_days_message": " está a 3 días de entregar cotización",
            "seven_days_message": " está a 7 días de entregar la cotización",
            "custommer_comments": "Cliente añadio Commentario",
            "customer_comments_message": " tiene un nuevo comentario de parte del cliente en la cotización",
            "seven_days_delivery_message": " está a 7 días de entregar",
            "add_shipment": "Nuevo Embarque",
            "add_shipment_message": " tiene un nuevo embarque",
            "all": "All Notifications"
        },
        "notificationsPermissions": {
            "project_created": "Proyecto creado",
            "quotation": "Cotización",
            "status": "Status",
            "quotation_file": "Archivo de Cotización",
            "add_scope": "Nuevo Fabricado",
            "pause_project": "Proyecto en Pausa",
            "delivery_date": "Fecha de Entrega",
            "payments": "Nuevo Pago",
            "add_shipment": "Nuevo Embarque",
            "update_shipment": "Embarque Actualizado",
            "update_claim": "Nuevo Reporte de Problema",
            "revision_approved": "Revision Aprovada",
            "reply_date": "Fecha de Respuesta de Revision",
            "add_rfi": "Nuevo RFI",
            "update_rfi": "RFI Actualizado"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Las contraseñas deben tener al menos seis caracteres y coincidir con la confirmación.",
            "reset": "¡Tu contraseña ha sido restablecida!",
            "sent": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "token": "Este token de restablecimiento de contraseña no es válido.",
            "user": "No podemos encontrar un usuario con esa dirección de correo electrónico.",
            "cant_login": "¿No puedes iniciar sesión?",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "payments": {
            "add": "Agregar pago",
            "edit": "Editar pago",
            "see": "Ver pago",
            "delete": "Eliminar pago",
            "not_find": "No se puede encontrar un pago con este codigo",
            "id": "Id",
            "payment_number": "Número de pago",
            "payment_number_placeholder": "Ingrese el numero de pago",
            "starting_date": "Fecha de inicio",
            "end_date": "Fecha de termino",
            "date_pay": "Fecha de pago",
            "date_pay_placeholder": "Ingrese la fecha de pago",
            "amount": "Monto",
            "amount_placeholder": "Ingrese el monto del pago",
            "type": "Tipo",
            "type_placeholder": "Ingrese el tipo de pago",
            "status": "Status",
            "created_by": "Creado por",
            "approved": "Aprobado",
            "receipt": "Recivido",
            "invoice_date": "Fecha de factura",
            "folio": "Folio",
            "balance": "Balance",
            "approve": "Aprobar",
            "hold": "En espera",
            "assigned": "Asignado",
            "no_assigned": "No asignado",
            "cancelled": "Cancelado",
            "created_at": "Creado en",
            "report_title": "Reporte de pagos"
        },
        "permissions": {
            "dashboard": "Ver Inicio",
            "to_quotes_index": "Ver Proyectos Por Cotizar",
            "projects_store": "Agregar Proyectos",
            "projects_destroy": "Eliminar Proyectos",
            "docs_reciveds_index": "Ver Fecha de Recepción de Documentos",
            "docs_reciveds_store": "Agregar Fecha de Recepción de Documentos",
            "quotations_store": "Crear Cotización",
            "categories_index": "Ver Artículos",
            "categories_store": "Agregar Artículos",
            "categories_destroy": "Eliminar Artículos",
            "revissions_index": "Ver Revisiones",
            "revissions_store": "Agregar Revisiones",
            "revissions_update": "Actualizar Revisiones",
            "quoteds_index": "Ver Cotizados",
            "project_details_index": "Ver Detalles del Proyecto",
            "project_details_store": "Agregar Detalles del Proyecto",
            "project_details_update": "Actualizar Detalles del Proyecto",
            "project_details_destroy": "Eliminar Detalles del Proyecto",
            "quotation_files_index": "Ver Archivo de Cotización",
            "quotation_files_store": "Agregar Archivo de Cotización",
            "status_store": "Cambiar Status del Proyecto",
            "in_order_index": "Ver Proyectos en Orden",
            "scope_index": "Ver Alcance",
            "scope_store": "Agregar Alcance",
            "gallery_index": "Ver Galería",
            "gallery_store": "Agregar a la Galería",
            "gallery_destroy": "Eliminar de la Galería",
            "delivery_deadline_update": "Actualizar Fecha de Entrega",
            "finish_projects_store": "Terminar Proyectos",
            "shipments_index": "Ver Embarques",
            "shipments_store": "Agregar Embarques",
            "shipments_update": "Actualizar Embarques",
            "claims_index": "Ver Reporte de Problemas",
            "claims_store": "Agregar Reporte de Problema",
            "claims_update": "Actualizar Reporte de Problema",
            "additionals_index": "Ver Adicionales",
            "additionals_store": "Agregar Adicionales",
            "rfis_index": "Ver RFIs",
            "rfis_store": "Agregar RFIs",
            "rfis_update": "Actualizar RFIs",
            "customers_index": "Ver Clientes",
            "customers_store": "Agregar Clientes",
            "customers_destroy": "Eliminar Clientes",
            "users_index": "Ver Usuarios",
            "users_store": "Agregar Usuarios",
            "users_update": "Actualizar Usuarios",
            "users_destroy": "Eliminar Usuarios",
            "payments_index": "Ver Pagos",
            "payments_store": "Agregar Pagos",
            "payments_update": "Actualizar Pagos",
            "amount_update": "Actualizar Monto",
            "finisheds_index": "Ver Terminados",
            "all": "Todos los Permisos"
        },
        "projects": {
            "add": "Agregar proyecto",
            "edit": "Editar proyecto",
            "see": "Detalles del proyecto",
            "delete": "Eliminar proyecto",
            "not_find": "No puede encontrar un proyecto con este codigo",
            "id": "Id",
            "status": "Status",
            "project": "Proyecto",
            "projects": "Proyectos",
            "project_name": "Nombre de proyecto",
            "project_name_placeholder": "Ingrese el nombre del proyecto",
            "currency": "Moneda",
            "currency_placeholder": "Seleccione la moneda",
            "currency_display": "Moneda",
            "location": "Locación",
            "location_placeholder": "Ingrese la locación del proyecto",
            "category_id": "Artículo",
            "category_id_placeholder": "Seleccione el artículo",
            "quantity": "Cantidad del alcance",
            "quantity_placeholder": "Ingrese la cantidad del alcance",
            "unit_measurement": "Unidad de medida del alcance",
            "unit_measurement_placeholder": "Ingrese la unidad de medida del alcance",
            "quantity2": "Cantidad",
            "quantity2_placeholder": "Ingrese la cantidad",
            "unit_measurement2": "Unidad de medida",
            "unit_measurement2_placeholder": "Ingrese la unidad de medida",
            "comments": "Comentarios",
            "comments_placeholder": "Ingrese los comentarios",
            "scope": "Alcance",
            "scope_placeholder": "Ingrese el alcance",
            "fabricated": "Fabricado",
            "fabricated_placeholder": "Ingrese lo fabricado",
            "shipped": "Embarcado",
            "shipped_placeholder": "Ingrese lo embarcado",
            "delivery_deadline": "Fecha de entrega",
            "delivery_deadline_placeholder": "Ingrese la fecha de entrega",
            "previous_delivery_deadline": "Fecha de entrega anterior",
            "total": "Total",
            "amount_paid": "Cantidad Pagada",
            "amount_due": "Cantidad por Pagar",
            "project_created_on": "Proyecto creado en",
            "project_created_by": "Proyecto creado por",
            "customer_id": "Cliente",
            "customer_id_placeholder": "Seleccione el cliente",
            "quotation": "Cotización",
            "quotations": "Cotizaciones",
            "quotation_start_date": "Fecha de inicio de la cotización",
            "quotation_created_by": "Cotizacion creada por",
            "quotation_approved": "Cotización aprobada",
            "amount": "Monto",
            "amount_placeholder": "Ingrese el monto",
            "fabricated_date": "Fecha de Actualización",
            "remission_number": "Número de remission",
            "addressee": "Destinatario",
            "shipped_date": "Fecha de embarque",
            "updated_at": "Actualizado en",
            "additional": "Adicional",
            "quotation_delivery_Date": "Fecha de entrega de cotización",
            "docs_date_recived": "Recepcion de documentos",
            "completion_date": "Fecha de completado",
            "quotation_delivery_date": "Fecha de entrega de cotización",
            "assigned_date": "Fecha que se assignó el proyecto",
            "customer": "Cliente",
            "contact": "Contacto",
            "address": "Dirección",
            "phone": "Telefono",
            "comments_quotation": "Comentarios de la cotización",
            "detailing_weeks": "Semanas de detalle de ingeniería",
            "approve_shop_drawings_weeks": "Semanas de aprobación de planos",
            "structure_weeks": "Semanas de estructura",
            "joist_weeks": "Semanas de joist",
            "date": "Fecha",
            "date_placeholder": "Ingrese la fecha del proyecto",
            "delivery_deadline_comments": "Comentarios de fecha de entrega",
            "delivery_deadline_comments_placeholder": "Ingrese comentarios sobre el cambio de fecha de entrega",
            "add_fabricated": "Agregar Fabricados",
            "upload_quotation_date": "Fecha de subida de Cotización",
            "upload_quotation_cano_date": "Fecha de subida de cotización Cano a Jss",
            "quotation_cano_steel": "Cotización de Cano Steel al Cliente",
            "quotation_cano": "Cotización de Cano a JSS",
            "recept_date": "Fecha de Recepción",
            "purchase_order": "Orden de Compra",
            "project_on_pause": "Proyecto en pausa",
            "date_of_delivery": "Fecha de Entrega",
            "customer_comments_quotation": "Comentarios del cliente en la cotización",
            "filename": "Nombre de archivo",
            "type": "Tipo",
            "type_placeholder": "Ingrese el tipo de cotización",
            "select_employee": "Seleccionar Empleados",
            "team": "Equipo",
            "received_date": "Fecha de recibido",
            "cannot_finish": "No es posible finalizar el proyecto",
            "cannot_finish_amountDueInvoice": "No es posible finalizar el proyecto por el Total Pendiente",
            "changes_orders": "Changes orders",
            "employee": "Empleado",
            "additive": "Additiva",
            "deductive": "Deductiva",
            "sequence": "Secuencia",
            "description": "Descripción",
            "mark": "Mark",
            "sequence_placeholder": "Ingrese la Secuencia",
            "description_placeholder": "Ingrese la descripción",
            "mark_placeholder": "Ingrese la marca",
            "add_category": "Agregar Categoria",
            "approve": "Aprobar",
            "approved": "Aprobar",
            "hold": "En espera",
            "assigned": "Asignado",
            "no_assigned": "No asignado",
            "cancelled": "Cancelado",
            "total_invoiced": "Total Facturado",
            "total_payments": "Total Pagado",
            "total_pending": "Total Pendiente",
            "total_remissions": "Remisiones totales",
            "created_at": "Creado en",
            "report_title": "Reporte de proyectos",
            "job_file": "Archivo de trabajo",
            "quotation_cano_structure": "Estructura, Misceláneos, montaje, Lamina "
        },
        "register": {
            "title": "Regístrate para obtener tu cuenta",
            "email": "Correo electrónico",
            "name": "Nombre de usuario",
            "password": "Contraseña",
            "register": "Crear cuenta",
            "message": "Al registrarte, confirmas que has leído y aceptado nuestros <a href=\"\/login\" class=\"content-vertical text-secondary\"> Términos de uso<\/a> y nuestra <a href=\"\/login\"> Política de privacidad<\/a>.",
            "back_login": "¿Ya tienes una cuenta de Controlla? Iniciar sesión",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "reset": {
            "subject": "Restablece tu contraseña de Controlla",
            "line_1": "Recibió este correo electrónico porque recibimos una solicitud de restablecimiento de contraseña para su cuenta.",
            "action": "Restablecer contraseña",
            "line_2": "Este enlace de restablecimiento de contraseña caducará en :count minutos.",
            "line_3": "Si no solicitó un restablecimiento de contraseña, no se requiere ninguna otra acción."
        },
        "revisions": {
            "add": "Agregar",
            "edit": "Editar Revision",
            "see": "Detalles de la Revision",
            "delete": "Delete Revision",
            "not_find": "No se puede encontrar una revision con este codigo.",
            "id": "Id",
            "remission_number": "Número de Remision",
            "remission_number_placeholder": "Ingrese el número de remision",
            "starting_date": "Fecha de envío",
            "starting_date_placeholder": "Ingrese la fecha de envío",
            "end_date": "Fecha de respuesta",
            "end_date_placeholder": "Ingrese la fecha de respuesta",
            "revision_number": "Número de Revision",
            "revision_number_placeholder": "Ingrese el número de revision",
            "status": "Status",
            "status_placeholder": "Ingrese el status de la revision",
            "created_by": "Creado por",
            "created_by_placeholder": "Ingrese el creador de la revision",
            "approved": "Aprobado",
            "package_name": "Nombre del paquete",
            "package_name_placeholder": "Ingrese el nombre del paquete",
            "type": "Tipo",
            "type_placeholder": "Ingrese el tipo de revision",
            "comments": "Comentarios",
            "comments_placeholder": "Ingrese los comentarios de la revision",
            "approve": "Aprobar",
            "hold": "En espera",
            "assigned": "Asignar",
            "no_assigned": "No asignado",
            "cancelled": "Cancelado",
            "see_attachment": "Ver adjunto",
            "created_at": "Creado en",
            "approved_date": "Aprovado en",
            "report_title": "Reporte de revisiones"
        },
        "rfis": {
            "request_for_information": "Solicitud de información",
            "project_name": "Nombre del proyecto",
            "project_id": "Proyecto",
            "project_id_placeholder": "Seleccione el proyecto",
            "customer_id": "Cliente",
            "customer_id_placeholder": "Seleccione el cliente",
            "location": "Locación",
            "requested_information": "Información solicitada",
            "requested_information_placeholder": "Ingrese la información solicitada",
            "requested_date": "Fecha de solicitud",
            "requested_date_placeholder": "Seleccione la fecha de solicitud",
            "rfi_number": "Número de RFI",
            "rfi_number_placeholder": "Ingrese el número de RFI",
            "type": "Tipo",
            "type_placeholder": "Seleccione el tipo de RFI",
            "revision": "Revision",
            "question": "Pregunta",
            "question_placeholder": "Ingrese la pregunta",
            "answer": "Respuesta",
            "answer_placeholder": "Ingrese la respuesta",
            "reply_date": "Fecha de respuesta",
            "created_by": "Creado por",
            "created_by_placeholder": "Ingrese el creador del RFI",
            "new_rfi": "Nuevo RFI",
            "attachment_answer": "Adjunto de la Respuesta",
            "already_answered": "Este RFI ya fue contestado",
            "reference": "Referencia",
            "reference_placeholder": "Ingrese la referencia",
            "delete_confirmation_rfi": "Are you sure you want to delete the :attribute?"
        },
        "shipments": {
            "add": "Agregar embarque",
            "edit": "Editar embarque",
            "view": "Ver embarque",
            "see": "Detalles del embarque",
            "delete": "Eliminar el embarque",
            "not_find": "No se puede encontrar un embarque con ese codigo.",
            "id": "Id",
            "remission_number": "Número de remision",
            "remission_number_placeholder": "Ingrese el número de remision",
            "addressee": "Destinatario",
            "addressee_placeholder": "Ingrese el destinatario del embarque",
            "shipped_date": "Fecha del embarque",
            "comments": "Comentarios",
            "comments_placeholder": "Ingrese los comentarios del embarque",
            "project_detail_id": "Detalle del proyecto",
            "quantity": "Cantidad",
            "shipped_with_currently_fabricated": "Cantidad",
            "updated_at": "Última actialización",
            "category_unit": "Artículo",
            "shipped": "Embarque",
            "shipment_complete_total": "Embarque",
            "add_shipped": "Agregar Embarques",
            "estimate_arrival": "Fecha estimada de llegada",
            "trucks_plates": "Placas del camión",
            "trucks_plates_placeholder": "Ingrese las placas",
            "flat_bed": "Flat bed",
            "flat_bed_placeholder": "Ingrese el flat bed",
            "transporter": "Transportador",
            "transporter_placeholder": "ingrese el nombre del transportador",
            "category": "Categoria",
            "scope": "Alcance",
            "approve": "Aprobado",
            "hold": "En espera",
            "assigned": "Asignado",
            "no_assigned": "No asignado",
            "cancelled": "Cancelado",
            "created_at": "Creado en",
            "report_title": "Reporte de Embarques"
        },
        "strings": {
            "dashboard": "Inicio",
            "overview": "Inicio",
            "user": "Usuario",
            "users": "Usuarios",
            "customer": "Cliente",
            "customers": "Clientes",
            "employee": "Empleado",
            "employees": "Empleados",
            "quotation": "Cotización",
            "quotations": "Cotizaciónes",
            "quotation_detail": "Cotización Detalle",
            "quotation_details": "Cotización Detalles",
            "profile": "Perfil",
            "profile_description": "Edite su información personal",
            "project": "Proyecto",
            "projects": "Proyectos",
            "revisions": "Revisiones",
            "categories": "Articulos",
            "quotes": "Cotizados",
            "invoices": "Facturas",
            "restore": "restablecer",
            "restore_proyect_messages": "Al restaurar el proyecto estará disponible en el módulo de inOrder",
            "restore_proyect": "Restaurar proyecto",
            "project_to_inOrder": "Mover proyecto a inOrder",
            "update_purchase_order": "El archivo será sustituido y el anterior desaparecerá",
            "description_view": "Un resumen de sus :attribute",
            "search": "Buscar :attribute por:columns ó :column",
            "filters": "Filtros",
            "clear": "Limpiar",
            "apply": "Aplicar",
            "select_date": "Selecciona una fecha",
            "multiple": "Selección multiple",
            "display_list": "Ver en lista",
            "display_grid": "Ver en grid (deshabilitado)",
            "print": "Imprimir",
            "delete": "Eliminar",
            "add": "Agregar",
            "addDetail": "Agregar Detalle",
            "edit": "Editar",
            "save": "Guardar",
            "accept": "Acceptar",
            "cancel": "Cancelar",
            "view": "Ver",
            "view_rfis": "Ver RFIs",
            "import": "Importar",
            "registered_on": "Registrado desde",
            "order_by": "Ordenado por",
            "options": "Más opciones",
            "notifications": "Notificaciones",
            "messages": "Mensajes",
            "no_notifications": "No tienes notificaciones",
            "no_messages": "No tienes mensajes",
            "read_all": "Marcar todo como leído",
            "exit": "Salir",
            "feedback": "Enviar Comentarios",
            "give_feedback": "Dar opinión",
            "shortcuts": "Atajos de teclado",
            "close_modal": "Cerrar modal",
            "create": "Crear registro",
            "view_selected": "Ver seleccionado",
            "edit_selected": "Editar seleccionado",
            "view_notifications": "Ver notificaciones",
            "find": "Buscar un registro",
            "register": "Registro",
            "update": "Actualizar",
            "detail": "Detalle",
            "confirm_deletion": "Confirmar eliminación del detalle",
            "details": "Detalles",
            "view_history": "Ver historial",
            "shipments": "Embarques",
            "payments": "Pagos",
            "inOrder": "En order",
            "finished": "Finalizar Proyecto",
            "finisheds": "Completados",
            "claims": "Reportes de problemas de embarque",
            "claim": "Reporte de problema de embarque",
            "download": "Descargar",
            "show_file": "Mostrar archivo",
            "show_attachments": "Mostrar Adjuntos",
            "show_question_attachments": "Mostrar adjuntos de pregunta",
            "show_answer_attachments": "Mostrar adjuntos de respuesta",
            "hide_attachments": "Ocultar Adjuntos",
            "hide_question_attachments": "Ocultar Adjuntos de respuesta",
            "hide_answer_attachments": "Ocultar Adjuntos de respuesta",
            "attachments": "Adjuntos",
            "attachment": "Adjunto",
            "gallery": "Galleria",
            "view_payments": "Ver pagos",
            "add_payment": "Agregar Pago",
            "additionals": "Adicionales",
            "revissions": "Revisiones",
            "permissions": "Permisos",
            "remisions": "Lista de Materiales",
            "report_dates": "Reporte de fechas",
            "download_backup": "Descargar Anterior",
            "add_invoice": "Agregar Factura",
            "changes_orders": "Changes orders",
            "views": "Vistas",
            "name": "Nombre",
            "date": "Fecha",
            "submittal": "Submittal",
            "you_sure": "Esta seguro?",
            "warning": "Alerta",
            "repeated_value": "Valor repetido",
            "save_anyway": "Guardar igualmente",
            "similar_values": "valores similares",
            "invalid_value": "valor invalido",
            "limit_exceeded": "valor excedido",
            "no_payments": "pagos no completados",
            "step0": " ingresa los siguientes datos para el formato del Excel ",
            "step1": "Ingresa la clave del producto en la primera columna",
            "step2": "Ingresa el id de la categoria en la segunda columna, lo puedes encontrar en el menú de \/in-orders -> scope -> Add details -> Add Category como el primer elemento de la lista ",
            "step3": "Ingresa la secuence del scope en la tercera columna, lo puedes encontrar como el numero del scope ",
            "step4": "Ingresa la descripción del producto en la cuarta columna",
            "step5": "Ingresa la cantidad de productos en la quinta columna",
            "step6": "Ingresa el id del proyecto en la sexta columna, lo puedes encontrar en el menú de \/in-orders como el primer elemento de la lista ",
            "cancelled": "Cancelado",
            "pending": "Pendiente",
            "approved": "Aprobado",
            "received": "Recibido",
            "send": "Enviado",
            "no_assigned": "No Asignado",
            "assigned": "Asignado",
            "on_hold": "En Espera",
            "hold": "En Espera",
            "open": "Abierto",
            "close": "Cerrado",
            "action_approved": "Aprobar",
            "action_received": "Recibir",
            "action_send": "Enviar",
            "action_active": "Activar",
            "action_inactive": "Inactivar",
            "create_quotation": "Crear Cotización",
            "add_amount": "Agregar Monto",
            "edit_amount": "Editar Monto",
            "approve": "Aprobar la Cotización",
            "see": "Ver",
            "add-quotation-file": "Agregar Archivo de Cotización",
            "see-quotation-file": "Ver Archivo de Cotización",
            "pause": "Pausa",
            "play": "Play",
            "active_project": "Proyecto Activo",
            "project_paused": "Proyecto en Pausa",
            "edit_notifications": "Editar Notificaciones",
            "select_employees": "Seleccionar Empleados",
            "select_contacts": "Seleccionar Contactos",
            "see_team": "Ver Equipo",
            "revise_and_resubmit": "Revisado y subido",
            "for_record_only": "Solo para registro",
            "make_corrections_as_noted": "Hacer correcciones como se indica",
            "mxn": "MXN",
            "usd": "USD",
            "to_quote": "Por Cotizar",
            "to_quote_description": "Gestione los proyectos por Cotizar",
            "quoted": "Cotizados",
            "quoted_description": "Gestione los proyectos Cotizados",
            "in_order": "En order",
            "in_orders": "En order",
            "rfi": "RFI",
            "rfis": "RFIs",
            "remision": "Remision",
            "in_order_description": "Gestione los proyectos en order",
            "edit_project": "Editar",
            "alert_employees_title": "Alerta",
            "alert_employees_texts": "No tienes empleados.",
            "scope": "Alcance",
            "image_logo": "Logo de Imagen",
            "english": "Ingles",
            "spanish": "Español",
            "download_a": "Descarga una",
            "sample_csv": "plantilla de CSV de muestra",
            "example_file": "para ver un ejemplo del formato requerido.",
            "created": "Creado"
        },
        "submittals": {
            "add": "Agregar",
            "edit": "Editar Submittal",
            "see": "Submittal Detalles",
            "delete": "Eliminar Submittal",
            "not_find": "No se puede encontrar un Submittals con este codigo.",
            "id": "Id",
            "remission_number": "Número de Remission",
            "remission_number_placeholder": "Ingrese el número de remission de los submittal's",
            "starting_date": "Fecha de envio",
            "starting_date_placeholder": "Ingrese la fecha de envio del submittal's",
            "end_date": "Fecha de respuesta",
            "end_date_placeholder": "Ingrese la fecha de envio del submittal's",
            "submittal_number": "Número de Submittal",
            "submittal_number_placeholder": "Ingrese el número de Submittal",
            "status": "Estado",
            "created_by": "Creado por",
            "created_by_placeholder": "Creado por",
            "approved": "Aprovado",
            "package_name": "Nombre de paquete",
            "package_name_placeholder": "Ingrese el nombre del paquete",
            "type": "Tipo",
            "type_placeholder": "Seleccione el tipo",
            "comments": "Comentarios",
            "comments_placeholder": "Ingrese algún comentario",
            "filename": "Nombre del archivo",
            "filename_placeholder": "Ingrese el nombre del archivo",
            "date": "Fecha",
            "date_placeholder": "Seleccione la fecha",
            "approve": "Aprovar",
            "hold": "En espera",
            "assigned": "Asignar",
            "no_assigned": "No asignar",
            "cancelled": "Cancelar",
            "see_attachment": "Ver archivo",
            "created_at": "Creado en",
            "approved_date": "Aprovado en",
            "report_title": "Reporte de proyecto"
        },
        "users": {
            "add": "Agregar usuario",
            "edit": "Editar usuario",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un usuario con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El usuario se ha activado",
            "inactived": "El usuario se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del usuario",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del usuario",
            "password": "Contraseña",
            "password_placeholder": "Ingresa la contraseña del usuario",
            "confirm_password": "Confirma Contraseña",
            "confirm_password_placeholder": "Confirma la contraseña del usuario",
            "role": "Rol",
            "role_placeholder": "Ingresa el rol del usuario",
            "status": "Estatus",
            "leave_empty": "Dejar vacío para mantener la contraseña actual.",
            "leave_empty_file": "Dejar vacío para mantener el archivo actual",
            "logo_file": "Archivo logo",
            "edit_customer": "Editar Customer",
            "created_at": "Creado en",
            "report_title": "Reporte de Usuarios"
        },
        "validation": {
            "accepted": "El campo :attribute debe ser aceptado.",
            "active_url": "El campo :attribute no es una URL válida.",
            "after": "El campo :attribute debe ser una fecha después a :date.",
            "after_or_equal": "El campo :attribute debe ser una fecha posterior o igual a :date.",
            "alpha": "El campo :attribute solo puede contener letras.",
            "alpha_dash": "El campo :attribute solo puede contener letras, números, guiones y guiones bajos.",
            "alpha_num": "El campo :attribute solo puede contener letras y números.",
            "array": "El campo :attribute debe ser una matriz.",
            "before": "El campo :attribute debe ser una fecha antes de :date.",
            "before_or_equal": "El campo :attribute debe ser una fecha antes o igual a :date.",
            "between": {
                "numeric": "El :attribute debe estar entre :min y :max.",
                "file": "El :attribute debe estar entre :min y :max kilobytes.",
                "string": "El :attribute debe estar entre :min y :max caracteres.",
                "array": "El :attribute debe estar entre :min y :max artículos."
            },
            "boolean": "El campo :attribute debe ser verdadero o falso.",
            "confirmed": "El :attribute la confirmación no coincide.",
            "date": "La :attribute no es una fecha valida.",
            "date_format": "La :attribute no coincide con el formato :format.",
            "different": "El :attribute y :other deben ser diferentes.",
            "digits": "El :attribute deben ser :digits dígitos.",
            "digits_between": "El :attribute debe estar entre :min y :max dígitos.",
            "dimensions": "El :attribute tiene dimensiones de imagen inválidas.",
            "distinct": "El :attribute campo tiene un valor duplicado.",
            "email": "El campo :attribute debe ser una dirección de correo electrónico válida.",
            "exists": "El seleccionado :attribute no es válido.",
            "file": "El :attribute debe ser un archivo.",
            "filled": "El :attribute campo debe tener un valor.",
            "gt": {
                "numeric": "El :attribute debe ser mayor que :value.",
                "file": "El :attribute debe ser mayor que :value kilobytes.",
                "string": "El :attribute debe ser mayor que :value caracteres.",
                "array": "El :attribute debe tener más que :value artículos."
            },
            "gte": {
                "numeric": "El :attribute debe ser mayor o igual que :value.",
                "file": "El :attribute debe ser mayor o igual que :value kilobytes.",
                "string": "El :attribute debe ser mayor o igual que :value caracteres.",
                "array": "El :attribute debe tener :value artículos o más."
            },
            "image": "La :attribute debe ser una imagen.",
            "in": "El seleccionado :attribute no es válido.",
            "in_array": "El :attribute campo no existe en :other.",
            "integer": "El :attribute debe ser un entero.",
            "ip": "La :attribute debe ser una dirección IP válida.",
            "ipv4": "La :attribute debe ser una dirección IPv4 válida.",
            "ipv6": "La :attribute debe ser una dirección IPv6 válida.",
            "json": "La :attribute debe ser una cadena JSON válida.",
            "lt": {
                "numeric": "El :attribute debe ser menor que :value.",
                "file": "El :attribute debe ser menor que :value kilobytes.",
                "string": "El :attribute debe ser menor que :value caracteres.",
                "array": "El :attribute debe tener menos que :value artículos."
            },
            "lte": {
                "numeric": "El :attribute debe ser menor o igual :value.",
                "file": "El :attribute debe ser menor o igual :value kilobytes.",
                "string": "El :attribute debe ser menor o igual :value caracteres.",
                "array": "El :attribute no debe tener más de :value artículos."
            },
            "max": {
                "numeric": "El :attribute no puede ser mayor que :max.",
                "file": "El :attribute no puede ser mayor que :max kilobytes.",
                "string": "El :attribute no puede ser mayor que :max caracteres.",
                "array": "El :attribute no puede tener más de :max artículos."
            },
            "mimes": "El :attribute must be a file of type: :values.",
            "mimetypes": "Los :attribute must be a file of type: :values.",
            "min": {
                "numeric": "El campo :attribute debe ser al menos de :min.",
                "file": "El campo :attribute debe ser al menos de :min kilobytes.",
                "string": "El campo :attribute debe ser al menos de :min caracteres.",
                "array": "El campo :attribute debe tener al menos :min artículos."
            },
            "not_in": "El seleccionado :attribute no es válido.",
            "not_regex": "El :attribute formato no es válido.",
            "numeric": "El campo :attribute tiene que ser un número.",
            "present": "El campo :attribute debe estar presente.",
            "regex": "El campo :attribute formato no es válido.",
            "required": "El campo :attribute es requerido.",
            "required_if": "El campo :attribute es requerido cuando :other es :value.",
            "required_unless": "El campo :attribute es requerido a menos que :other es en :values.",
            "required_with": "El campo :attribute es requerido cuando :values esta presente.",
            "required_with_all": "El campo :attribute es requerido cuando :values esta presente.",
            "required_without": "El campo :attribute es requerido cuando :values no esta presente.",
            "required_without_all": "El campo :attribute es requerido cuando ninguno de :values estan presentes.",
            "same": "El campo :attribute debe coincidir con :other.",
            "size": {
                "numeric": "El :attribute debe ser :size.",
                "file": "El :attribute debe ser :size kilobytes.",
                "string": "El :attribute debe ser :size caracteres.",
                "array": "El :attribute debe contener :size artículos."
            },
            "string": "El :attribute debe ser un texto.",
            "timezone": "El :attribute debe ser una zona válida.",
            "unique": "The :attribute has already been taken",
            "uploaded": "El :attribute no se pudo cargar.",
            "url": "El :attribute formato no válido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verifica tu correo electrónico",
            "check_email": "Necesitamos verificar tu dirección de email",
            "check_email_label": "Consulta el correo electrónico para finalizar el registro. Te hemos enviado un enlace de registro a la dirección:",
            "resend_email": "¿No has recibido el enlace de registro? Volver a enviarlo",
            "resend_succesfully": "Reenviado satisfactoriamente",
            "reset_email": "Cambiar dirección de correo electrónico"
        },
        "welcome": {
            "subject": "Bienvenido a Controlla",
            "line_1": "Bienvenido.",
            "action": "Pruébalo ahora"
        }
    },
    "en": {
        "additionals": {
            "add": "Add address",
            "edit": "Edit address",
            "delete": "Delete address",
            "not_find": "Can not find a address with this code.",
            "id": "Id",
            "project_name": "Project Name",
            "location": "Location",
            "project_created_on": "Project created on",
            "project_created_by": "Project created by",
            "docs_date_recived": "Docs date received",
            "created_at": "Created at",
            "report_title": "Address Report"
        },
        "articles": {
            "add": "Add address",
            "edit": "Edit address",
            "delete": "Delete address",
            "not_find": "Can not find a address with this code.",
            "id": "Id",
            "category": "Category",
            "category_placeholder": "Enter the category",
            "type": "Type",
            "created_at": "Created at",
            "report_title": "Categories Report"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in :seconds seconds."
        },
        "change_orders": {
            "add": "Add Change Order",
            "edit": "Edit Change Order",
            "name": "Name",
            "status": "Status",
            "type": "Type",
            "amount": "Amount",
            "created_by": "Created By",
            "date": "Date",
            "name_placeholder": "Enter the Name",
            "type_placeholder": "Enter the Type",
            "amount_placeholder": "Enter the Amount",
            "date_placeholder": "Enter the Date",
            "category_id": "Category",
            "category_id_placeholder": "Select the Category",
            "quantity": "Quantity scope",
            "quantity_placeholder": "Enter the Quantity scope",
            "unit_measurement": "Unit measurement scope",
            "unit_measurement_placeholder": "Enter the Unit measurement scope",
            "quantity2": "Quantity",
            "quantity2_placeholder": "Enter the Quantity",
            "unit_measurement2": "Unit measurement",
            "unit_measurement2_placeholder": "Enter the Unit measurement",
            "comments": "Comments",
            "comments_placeholder": "Enter the Comments",
            "see_created_attachment": "See created attachment",
            "see_approved_attachment": "See approved attachment",
            "approve": "Approve",
            "cancel": "Cancell"
        },
        "claims": {
            "add": "Add claim",
            "edit": "Edit claim",
            "delete": "Delete claim",
            "not_find": "Can not find a claim with this code.",
            "id": "Id",
            "claims": "Claims",
            "claim": "Claim",
            "date": "Date",
            "date_placeholder": "Enter the claim's date",
            "question": "Question",
            "question_placeholder": "Enter the claim's question",
            "answer": "Answer",
            "answer_placeholder": "Enter the claim's answer",
            "customer_id": "Created By",
            "project_id": "Project",
            "shipment_id": "Shipment",
            "already_answered": "This claim is already answered",
            "created_at": "Created at",
            "report_title": "Claim Report"
        },
        "customers": {
            "add": "Add customer",
            "edit": "Edit customer",
            "delete": "Delete customer",
            "not_find": "Can not find a client with this code.",
            "id": "Id",
            "name": "Company Name",
            "name_placeholder": "Enter the company name",
            "contact": "Contact",
            "contact_placeholder": "Enter the customer's contact",
            "address": "Address",
            "address_placeholder": "Enter the customer's address",
            "state": "State",
            "state_placeholder": "Enter the state",
            "phone": "Phone",
            "phone_placeholder": "Enter the customer's phone",
            "email": "Email",
            "email_placeholder": "Enter the customer's email",
            "website": "Website",
            "website_placeholder": "Enter the customer's website",
            "created_at": "Created at",
            "report_title": "Customers Report"
        },
        "employees": {
            "add": "Add employee",
            "edit": "Edit employee",
            "view": "View employee",
            "delete": "Delete employee",
            "not_find": "Can not find a client with this code.",
            "id": "Id",
            "name": "Company Name",
            "name_placeholder": "Enter the company name",
            "contact": "Contact",
            "contact_placeholder": "Enter the employee's contact",
            "address": "Address",
            "address_placeholder": "Enter the employee's address",
            "state": "State",
            "state_placeholder": "Enter the state",
            "phone": "Phone",
            "phone_placeholder": "Enter the employee's phone",
            "email": "Email",
            "email_placeholder": "Enter the employee's email",
            "website": "Website",
            "website_placeholder": "Enter the employee's website",
            "view_payments": "View Payments",
            "created_at": "Created at",
            "report_title": "Customers Report"
        },
        "errors": {
            "fatal_error": "A fatal error occurred, please contact us.",
            "generic_error": "An error occurred, please try again.",
            "unauthorized": "Unauthorized.",
            "forbidden": "Forbidden.",
            "connection_error": "Connection error",
            "action_unauthorized": "This action is unauthorized.",
            "info": "Error."
        },
        "feedback": {
            "rate": "What do you think of this experience?",
            "comment": "Tell us how was your experience?",
            "contact_me": "Controlla can contact me about my feedback."
        },
        "field_used_drawings": {
            "add": "Add Field Used Drawing",
            "edit": "Edit Field Used Drawing",
            "name": "Name",
            "status": "Status",
            "type": "Type",
            "amount": "Amount",
            "created_by": "Created By",
            "date": "Date",
            "name_placeholder": "Enter the Name",
            "type_placeholder": "Enter the Type",
            "amount_placeholder": "Enter the Amount",
            "date_placeholder": "Enter the Date",
            "category": "Category",
            "category_placeholder": "Select the Category",
            "drawing_number": "Drawing number",
            "drawing_number_placeholder": "Enter the drawing number",
            "title": "Title",
            "title_placeholder": "Enter the title",
            "revision": "Revision",
            "revision_placeholder": "Enter the revision",
            "approve": "Approve",
            "cancel": "Cancell"
        },
        "finisheds": {
            "add": "Add project",
            "edit": "Edit project",
            "delete": "Delete project",
            "not_find": "Can not find a client with this code.",
            "id": "Id",
            "completion_date": "Completion Date",
            "completion_date_placeholder": "Enter the project's completion date",
            "project_name": "Project Name",
            "location": "Location",
            "amount": "Amount",
            "currency": "Currency",
            "project_created_on": "Project Created On",
            "quotation_start_date": "Quotation Start Date",
            "delivery_deadline": "Delivery Deadline",
            "customer": "Customer",
            "created_at": "Created at",
            "report_title": "Projects Report"
        },
        "front": {
            "added_successfully": "It has been added successfully.",
            "updated_successfully": "It has been updated successfully.",
            "deleted_successfully": "It has been deleted successfully.",
            "imported_successfully": "It has been imported successfully.",
            "reloaded_successfully": "It has been reloaded successfully.",
            "delete_modal": "Delete",
            "delete_confirmation": "Are you sure you want to delete the :model :attribute?",
            "delete_confirmation2": "Are you sure you want to delete :model :attribute?",
            "action_confirmation": "Are you sure you want to :action this :model?",
            "action_confirmation2": "Are you sure you want to :action this :model?",
            "cancel_modal": "Cancel",
            "cancel_confirmation2": "Are you sure you want to cancel this project? It cant be undone",
            "import_modal": "Import :model from CSV or Excel file",
            "role": "To Manage Permissions Select Correct Role",
            "role_validate": "to manage the permissions it is necessary to select the manual role, if another role is selected, the corresponding permissions for that role will be taken.",
            "select_permissions": "Select Permissions",
            "select_permissions_text": "Select Some Permission to Save the User or Select Other Role"
        },
        "gallery": {
            "add": "Add photo to gallery",
            "edit": "Edit photo from gallery",
            "delete": "Delete from gallery",
            "not_find": "Can not find a gallery with this code.",
            "id": "Id",
            "description": "Description",
            "description_placeholder": "Enter the gallery description",
            "date": "Date",
            "shipment_id": "Shipment",
            "shipment_id_placeholder": "Enter the gallery shipment",
            "remision": "Type",
            "remision_placeholder": "Select the Type",
            "created_at": "Created at",
            "report_title": "Gallery Report"
        },
        "invoices": {
            "add": "Add Invoice",
            "edit": "Edit Invoice",
            "see": "Invoice Details",
            "delete": "Delete Invoice",
            "not_find": "Can not find a Invoices with this code.",
            "delete_payment_confirmation": "Are you sure you want to delete the payment?",
            "delete_invoice_confirmation": "Are you sure you want to delete the invoice?",
            "folio": "Folio",
            "invoice_date": "Invoice Date",
            "payments": "Payments",
            "total": "Total",
            "paidout": "Paid Out",
            "remaining": "Remaining",
            "amount": "Amount",
            "amount_placeholder": "Enter the invoice's amount",
            "available_amount": "available for billing",
            "exceeded_amount": "The amount must be less or equal to: ",
            "type": "Type",
            "type_placeholder": "Enter the invoice's type",
            "receipt": "Receipt",
            "folio_placeholder": "Enter the Folio",
            "balance": "Balance"
        },
        "login": {
            "email": "Email",
            "password": "Password",
            "keep_connected": "Keep connected",
            "forgot_password": "Forgot password",
            "login": "Login",
            "logout": "Logout",
            "reset_password": "Reset password",
            "send_reset_link": "Send the reset link",
            "password_confirmation": "Password confirmation",
            "still_having_trouble": "Still having trouble logging in?",
            "havent_account": "Don't have a account?",
            "back_login": "Back to login",
            "register": "Create account",
            "welcome": "Welcome",
            "description": "Description app"
        },
        "notifications": {
            "empty_title": "No notifications at this time",
            "empty_msg": "When your team starts doing things, we will show the notifications here.",
            "add_new_project": "New Project!",
            "add_new_project_message": " has been added",
            "docs_recived": "Docs Recived",
            "docs_date_recived_message": " docs has been recived",
            "quotation": "New Quotation",
            "quotation_message": " quotation has been created",
            "revision_approved": "Revision Approved",
            "revision_approved_message": " revision has been approved",
            "quotation_file": "New Quotation File",
            "quotation_file_message": " a new quotation file has been upload",
            "project_assigned": "Project assigned",
            "assigned_message": " has been assigned",
            "add_rfi": "New RFI",
            "add_rfi_message": " has been added",
            "update_rfi": "RFI Update",
            "update_rfi_message": " has been answered",
            "pause_project": "Project on Pause",
            "pause_project_message": " has been update",
            "updated_shipment": "Updated Shipment",
            "updated_shipment_message": " has been updated",
            "reply_date": "New Reply Date",
            "reply_date_message": " has been added",
            "delivery_deadline": "Delivery Deadline is Coming!",
            "delivery_deadline_message": " delivery deadline has been changed",
            "updated_scope": "Updated Scope",
            "updated_scope_message": " has been updated",
            "add_claim": "New Claim",
            "add_claim_message": " has a new claim",
            "claim_updated": "Claim Answered",
            "claim__updated_message": " has a new claim answered",
            "add_new_additional": "New Additional",
            "add_new_additional_message": " has a new additional",
            "add_new_payment": "New Payment",
            "add_new_payment_message": " has been a new payment",
            "delivery_date": "Quotation Delivery is Coming!",
            "three_days_message": " it is 3 days from delivering the quotation",
            "seven_days_message": " it is 7 days from delivering the quotation",
            "custommer_comments": "Customer Commented",
            "customer_comments_message": " has a new comment from a customer in the quotation",
            "seven_days_delivery_message": " it is 7 days from delivering deadline",
            "add_shipment": "New Shipment",
            "add_shipment_message": " has a new shipment",
            "all": "Todas las Notificaciones"
        },
        "notificationsPermissions": {
            "project_created": "Project Created",
            "quotation": "Quotation",
            "status": "Status",
            "quotation_file": "Quotation File",
            "add_scope": "Add Scope",
            "pause_project": "Pause Project",
            "delivery_date": "Delivery Date",
            "payments": "New Payment",
            "add_shipment": "New Shipment",
            "update_shipment": "Update Shipment",
            "update_claim": "Update Claim",
            "revision_approved": "Revision Approved",
            "reply_date": "Reply Date",
            "add_rfi": "Add RFI",
            "update_rfi": "Update Rfi"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "cant_login": "Can't you login?",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "payments": {
            "add": "Add Payment",
            "edit": "Edit Payment",
            "see": "Ver pago",
            "delete": "Delete Payment",
            "not_find": "Can not find a payment with this code.",
            "id": "Id",
            "payment_number": "Payment Number",
            "payment_number_placeholder": "Enter the payment's number",
            "starting_date": "Starting Date",
            "end_date": "End Date",
            "date_pay": "Date of Pay",
            "date_pay_placeholder": "Enter the payment's date",
            "amount": "Amount",
            "amount_placeholder": "Enter the payment's amount",
            "type": "Type",
            "type_placeholder": "Enter the payment's type",
            "status": "Status",
            "created_by": "Created By",
            "approved": "Approved",
            "receipt": "Receipt",
            "invoice_date": "Invoice Date",
            "folio": "Folio",
            "balance": "Balance",
            "approve": "approved",
            "hold": "On hold",
            "assigned": "Assigned",
            "no_assigned": "No assigned",
            "cancelled": "Cancelled",
            "created_at": "Created at",
            "report_title": "Project Report"
        },
        "permissions": {
            "dashboard": "View Dashboard",
            "search_bar": "View Search Bar",
            "reports": "View Reports",
            "to_quotes_index": "View To Quotes",
            "projects_store": "Add Project",
            "projects_destroy": "Delete Projects",
            "docs_reciveds_index": "View Docs Date Recived",
            "docs_reciveds_store": "Add Docs Date Recived",
            "quotations_store": "Create Quotation",
            "categories_index": "View Categories",
            "categories_store": "Add Categories",
            "categories_destroy": "Delete Categories",
            "revissions_index": "View Revisions",
            "revissions_store": "Add Revisions",
            "revissions_update": "Update Revisions",
            "quoteds_index": "View Quoteds",
            "project_details_index": "View Projects Details",
            "project_details_store": "Add Project Details",
            "project_details_update": "Update Project Details",
            "project_details_destroy": "Delete Project Details",
            "quotation_files_index": "View Quotation File",
            "quotation_files_store": "Add Quotation File",
            "status_store": "Change Project Status",
            "in_order_index": "View In Orders",
            "scope_index": "View Scope",
            "scope_store": "Add Scope",
            "submittal_index": "View Submittal",
            "submittal_store": "Add Submittal",
            "submittal_destroy": "Delete Submittal",
            "submittal_details_index": "View Submittal Replies",
            "submittal_details_store": "Reply Submittal",
            "submittal_details_destroy": "Delete Submittal Replies",
            "field_used_drawings_index": "View Drawings",
            "field_used_drawings_store": "Add Drawings",
            "field_used_drawings_update": "Update Drawings",
            "field_used_drawings_destroy": "Delete Drawings",
            "gallery_index": "View Gallery",
            "gallery_store": "Add to the Gallery",
            "gallery_destroy": "Delete from the Gallery",
            "delivery_deadline_update": "Update Delivery Deadline",
            "finish_projects_store": "Finish Projects",
            "shipments_index": "View Shipments",
            "shipments_store": "Add Shipments",
            "shipments_update": "Update Shipments",
            "claims_index": "View Claims",
            "claims_store": "Add Claims",
            "claims_update": "Update Claims",
            "additionals_index": "View Additionals",
            "additionals_store": "Add Additionals",
            "rfis_index": "View RFIs",
            "rfis_store": "Add RFIs",
            "rfis_update": "Update RFIs",
            "customers_index": "View Customers",
            "customers_store": "Add Customers",
            "customers_destroy": "Delete Customer",
            "employees_index": "View Employees",
            "employees_store": "Add Employees",
            "employees_destroy": "Delete Employee",
            "select_employees": "Select Employees",
            "select_contacts": "Select Contacts",
            "users_index": "View Users",
            "users_store": "Add Users",
            "users_update": "Update Users",
            "users_destroy": "Delete Users",
            "payments_index": "View Payments",
            "payments_store": "Add Payments",
            "payments_update": "Update Payments",
            "finisheds_index": "View Finisheds",
            "amount_update": "Update Amount",
            "all": "All Permissions"
        },
        "projects": {
            "add": "Add projects",
            "edit": "Edit projects",
            "see": "Project Details",
            "delete": "Delete projects",
            "not_find": "Can not find a projects with this code.",
            "id": "Id",
            "status": "Status",
            "project": "Project",
            "projects": "Projects",
            "project_name": "Project Name",
            "project_name_placeholder": "Enter the Project Name",
            "currency": "Currency",
            "currency_placeholder": "Enter the Currency",
            "currency_display": "Currency",
            "location": "Location",
            "location_placeholder": "Enter the Location",
            "category_id": "Category",
            "category_id_placeholder": "Select the Category",
            "quantity": "Quantity scope",
            "quantity_placeholder": "Enter the Quantity scope",
            "unit_measurement": "Unit measurement scope",
            "unit_measurement_placeholder": "Enter the Unit measurement scope",
            "quantity2": "Quantity",
            "quantity2_placeholder": "Enter the Quantity",
            "unit_measurement2": "Unit measurement",
            "unit_measurement2_placeholder": "Enter the Unit measurement",
            "comments": "Comments",
            "comments_placeholder": "Enter the Comments",
            "scope": "Scope",
            "scope_placeholder": "Enter the scope",
            "fabricated": "Fabricated",
            "fabricated_placeholder": "Enter the fabricated",
            "shipped": "Shipped",
            "shipped_placeholder": "Enter the shipped",
            "delivery_deadline": "Delivery Deadline",
            "delivery_deadline_placeholder": "Enter a delivery deadline",
            "previous_delivery_deadline": "Previous delivery deadline",
            "total": "Total",
            "amount_paid": "Amount Paid",
            "amount_due": "Amount Due",
            "project_created_on": "Project created on",
            "project_created_by": "Project created by",
            "customer_id": "Customer",
            "customer_id_placeholder": "Select the customer",
            "quotation": "Quotation",
            "quotations": "Quotations",
            "quotation_start_date": "Quotation start date",
            "quotation_created_by": "Quotation created by",
            "quotation_approved": "Quotation approved",
            "amount": "Amount",
            "amount_placeholder": "Enter the Amount",
            "fabricated_date": "Update Date",
            "remission_number": "Remission Number",
            "addressee": "Addressee",
            "shipped_date": "Shipped Date",
            "updated_at": "Last Updated At",
            "additional": "Additional",
            "quotation_delivery_Date": "Quotation Delivery Date",
            "docs_date_recived": "Docs Date Received",
            "completion_date": "Completion Date",
            "quotation_delivery_date": "Quotation Delivery Date",
            "assigned_date": "Assigned Date",
            "customer": "Customer",
            "contact": "Contact",
            "address": "Address",
            "phone": "Phone",
            "comments_quotation": "Quotation comments",
            "detailing_weeks": "Detailing weeks",
            "approve_shop_drawings_weeks": "Approve Shop Drawings Weeks",
            "structure_weeks": "Structure weeks",
            "joist_weeks": "Joist weeks",
            "date": "Date",
            "date_placeholder": "Enter the project's date",
            "delivery_deadline_comments": "Delivery Deadline Comments",
            "delivery_deadline_comments_placeholder": "Enter the project's Delivery Deadline Comments",
            "add_fabricated": "Add Fabricateds",
            "upload_quotation_date": "Upload quotation date",
            "upload_quotation_cano_date": "Upload quotation Cano To Jss date",
            "quotation_cano_steel": "Quotation Cano Steel To Client",
            "quotation_cano": "Quotation Cano To Jss",
            "recept_date": "Reception Date",
            "purchase_order": "Purchase Order",
            "update_purchase_order": "Update Purchase Order",
            "upload_purchase_order": "Upload Purchase Order",
            "project_on_pause": "Project on pause",
            "date_of_delivery": "Date of Delivery",
            "customer_comments_quotation": "Customer Comments Quotation",
            "filename": "Filename",
            "total_remissions": "Total Remissions",
            "received_date": "Received Date",
            "new_deadline": "New Deadline",
            "type": "Type",
            "type_placeholder": "Enter the quotation's type",
            "select_employee": "Select Employee",
            "team": "Project Team",
            "cannot_finish": "cannot finish",
            "cannot_finish_amountDueInvoice": "cannot finish for Total Pending",
            "changes_orders": "Changes orders",
            "additive": "Additive",
            "deductive": "Deductive",
            "sequence": "Sequence",
            "description": "Description",
            "mark": "Mark",
            "sequence_placeholder": "Enter the Sequence",
            "description_placeholder": "Enter the Description",
            "mark_placeholder": "Enter the Mark",
            "employee": "Employee",
            "approve": "approved",
            "approved": "Approved",
            "hold": "On hold",
            "assigned": "Assigned",
            "no_assigned": "No assigned",
            "cancelled": "Cancelled",
            "total_invoiced": "Total Invoiced",
            "total_payments": "Total Payments",
            "total_pending": "Total Pending",
            "shipment": "Shipment",
            "created_at": "Created at",
            "report_title": "Project Report",
            "job_file": "Job file",
            "quotation_cano_structure": "Structure, Miscellaneous, Mounting, Sheet",
            "add_category": "Add Category"
        },
        "register": {
            "title": "Sign up to get your account",
            "email": "Email",
            "name": "Username",
            "password": "Password",
            "register": "Create account",
            "message": "By registering, confirm that you have read and accepted our  <a href=\"\/login\"> Terms of use <\/a> and our <a href=\"\/login\"> Privacy policy <\/a>.",
            "back_login": "Already have an Controlla account? Log in",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "reset": {
            "subject": "Reset your Controlla Password",
            "line_1": "You are receiving this email because we received a password reset request for your account.",
            "action": "Reset Password",
            "line_2": "This password reset link will expire in :count minutes.",
            "line_3": "If you did not request a password reset, no further action is required."
        },
        "revisions": {
            "add": "Agregar",
            "edit": "Edit Revision",
            "see": "Revision Details",
            "delete": "Delete Revision",
            "not_find": "Can not find a Revisions with this code.",
            "id": "Id",
            "remission_number": "Remission Number",
            "remission_number_placeholder": "Enter the revision's remission number",
            "starting_date": "Sending Date",
            "starting_date_placeholder": "Enter the revision's sending date",
            "end_date": "Reply Date",
            "end_date_placeholder": "Enter the revision's reply date",
            "revision_number": "Revision Number",
            "revision_number_placeholder": "Enter the revision's number",
            "status": "Status",
            "status_placeholder": "Enter the revision's status",
            "created_by": "Created by",
            "created_by_placeholder": "Enter this revision's creator",
            "approved": "Approved",
            "approved_placeholder": "Enter the revision's approved",
            "package_name": "Package name",
            "package_name_placeholder": "Enter the revision's package name",
            "type": "Type",
            "type_placeholder": "Enter the revision's type",
            "comments": "Comments",
            "comments_placeholder": "Enter the revision's comments",
            "approve": "approved",
            "hold": "On hold",
            "assigned": "Assigned",
            "no_assigned": "No assigned",
            "cancelled": "Cancelled",
            "see_attachment": "See Attachment",
            "created_at": "Created at",
            "approved_date": "Approved at",
            "report_title": "Project Report"
        },
        "rfis": {
            "request_for_information": "Request For Information",
            "project_name": "Project name",
            "project_id": "Project",
            "project_id_placeholder": "Enter the project",
            "customer_id": "Customer",
            "customer_id_placeholder": "Enter the customer",
            "location": "Location",
            "requested_information": "Requested information",
            "requested_information_placeholder": "Enter the Requested information",
            "requested_date": "Requested date",
            "requested_date_placeholder": "Select the requested date",
            "rfi_number": "RFI number",
            "rfi_number_placeholder": "Enter the RFI number",
            "type": "Type",
            "type_placeholder": "Enter the Type",
            "revision": "Revision",
            "question": "Question",
            "question_placeholder": "Enter the Question",
            "answer": "Answer",
            "answer_placeholder": "Enter the Answer",
            "reply_date": "Reply date",
            "created_by": "Created by",
            "created_by_placeholder": "Created by",
            "new_rfi": "New RFI",
            "attachment_answer": "Attachment Answer",
            "already_answered": "This RFI is already answered",
            "reference": "Reference",
            "reference_placeholder": "Enter the reference",
            "delete_confirmation_rfi": "Are you sure you want to delete the :attribute?"
        },
        "shipments": {
            "add": "Add Shipment",
            "view": "View Shipment",
            "edit": "Edit Shipment",
            "see": "Shipment Details",
            "delete": "Delete Shipment",
            "not_find": "Can not find a shipments with this code.",
            "id": "Id",
            "remission_number": "Remission Number",
            "remission_number_placeholder": "Enter the shipment's remission number",
            "addressee": "Addressee",
            "addressee_placeholder": "Enter the shipment's addressee",
            "shipped_date": "Shipped Date",
            "amount": "Amount",
            "amount_placeholder": "Enter the shipment's amount",
            "currency": "Currency",
            "currency_placeholder": "Enter the shipment's currency",
            "comments": "Comments",
            "comments_placeholder": "Enter the shipment's comments",
            "project_detail_id": "Project Detail Id",
            "quantity": "Quantity",
            "shipped_with_currently_fabricated": "Quantity",
            "updated_at": "Last Update",
            "category_unit": "Category",
            "shipped": "Shipped",
            "shipment_complete_total": "Shipped",
            "add_shipped": "Add Shipments",
            "estimate_arrival": "Estimate arrival",
            "trucks_plates": "Trucks plates",
            "trucks_plates_placeholder": "Enter the shipment's trucks plates",
            "flat_bed": "Flat bed",
            "flat_bed_placeholder": "Enter the shipment's flat bed",
            "transporter": "Transporter",
            "transporter_placeholder": "Enter the shipment's transporter",
            "category": "Category",
            "scope": "Scope",
            "approve": "approved",
            "hold": "On hold",
            "assigned": "Assigned",
            "no_assigned": "No assigned",
            "cancelled": "Cancelled",
            "created_at": "Created at",
            "report_title": "Project Report"
        },
        "strings": {
            "dashboard": "Dashboard",
            "overview": "Overview",
            "user": "User",
            "users": "Users",
            "customer": "Customer",
            "customers": "Customers",
            "employee": "Employee",
            "employees": "Employees",
            "contact": "Contact",
            "contacts": "Contacts",
            "quotation": "Quotation",
            "quotations": "Quotations",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "profile": "Profile",
            "profile_description": "Edit your personal information",
            "project": "Project",
            "projects": "Projects",
            "revisions": "Revisions",
            "categories": "Categories",
            "quotes": "Quotes",
            "invoices": "Invoices",
            "submittal": "Submittal",
            "submittals": "Submittals",
            "field_used_drawing": "Field Used Drawing",
            "field_used_drawings": "Field Used Drawings",
            "update_purchase_order": "The file will be replaced and the previous one will disappear",
            "description_view": "An Overview of your :attribute",
            "search": "Search :attribute by:columns or :column",
            "filters": "Filters",
            "clear": "Clear",
            "apply": "Apply",
            "select_date": "Select a date",
            "multiple": "Multiple",
            "display_list": "Display list",
            "display_grid": "Display grid (enabled)",
            "print": "Print",
            "delete": "Delete",
            "add": "Add",
            "addDetail": "Add Detail",
            "edit": "Edit",
            "save": "Save",
            "accept": "Accept",
            "cancel": "Cancel",
            "view": "View",
            "view_rfis": "View RFIs",
            "import": "Import",
            "registered_on": "Registered on",
            "order_by": "Order by",
            "options": "More options",
            "notifications": "Notifications",
            "messages": "Messages",
            "no_notifications": "No notifications",
            "no_messages": "No messages",
            "read_all": "Mark as read",
            "exit": "Exit",
            "feedback": "Feedback",
            "give_feedback": "Give feedback",
            "shortcuts": "Shortcuts",
            "close_modal": "Close modal",
            "create": "Create resource",
            "view_selected": "View selected",
            "edit_selected": "Edit selected",
            "view_notifications": "View notifications",
            "find": "find",
            "register": "Register",
            "update": "Update",
            "details": "Details",
            "detail": "Detail",
            "confirm_deletion": "Confirm deletion of detail",
            "view_history": "View History",
            "shipments": "Shipments",
            "payments": "Payments",
            "inOrder": "In Order",
            "finished": "Finish Project",
            "finisheds": "Completed",
            "restore": "restore",
            "restore_proyect_messages": "When you restore the project it will be available in the inOrder module",
            "restore_proyect": "Restore project",
            "project_to_inOrder": "Project to inOrder",
            "claims": "Claims",
            "claim": "Claim",
            "download": "Download",
            "show_file": "Show file",
            "show_question_attachments": "Show Question Attachments",
            "hide_question_attachments": "Hide Question Attachments",
            "show_answer_attachments": "Show Answer Attachments",
            "hide_answer_attachments": "Hide Answer Attachments",
            "attachments": "Attachments",
            "attachment": "Attachment",
            "gallery": "Gallery",
            "hide_attachments": "Hide Attachments",
            "view_payments": "View payments",
            "add_payment": "Add Payment",
            "additionals": "Additionals",
            "revissions": "Revissions",
            "permissions": "Permissions",
            "remisions": "Bill of Materials",
            "report_dates": "Report Dates",
            "download_backup": "Download Backup",
            "add_invoice": "Add Invoice",
            "received_date": "Received Date",
            "changes_orders": "Changes orders",
            "views": "Views",
            "name": "Name",
            "date": "Date",
            "you_sure": "Are you sure?",
            "warning": "Warning",
            "repeated_value": "Repeated value",
            "save_anyway": "Save anyway",
            "similar_values": "Similar values",
            "invalid_value": "Invalid value",
            "limit_exceeded": "Limit exceeded",
            "no_payments": "payments not completed",
            "step0": "Enter the following data for the Excel format",
            "step1": "Enter the product code in the first column",
            "step2": "Enter the category ID in the second column, you can find it in the menu of \/in-orders -> scope -> Add details -> Add Category as the first item in the list",
            "step3": "Enter the scope sequence in the third column, you can find it as the scope number",
            "step4": "Enter the product description in the fourth column",
            "step5": "Enter the quantity of products in the fifth column",
            "step6": "Enter the project ID in the sixth column, you can find it in the menu of \/in-orders as the first item on the list",
            "cancelled": "Cancelled",
            "pending": "Pending",
            "approved": "Approved",
            "received": "Received",
            "send": "Sent",
            "no_assigned": "No assigned",
            "assigned": "Assigned",
            "on_hold": "On hold",
            "hold": "On hold",
            "open": "Open",
            "close": "Close",
            "action_approved": "Approved",
            "action_received": "Received",
            "action_send": "Send",
            "action_active": "Active",
            "action_inactive": "Inactive",
            "create_quotation": "Create Quotation",
            "add_amount": "Add amount",
            "edit_amount": "Edit amount",
            "approve": "Approve the quotation",
            "see": "See",
            "add-quotation-file": "Add Quotation File",
            "see-quotation-file": "See Quotation File",
            "pause": "Pause",
            "play": "Play",
            "active_project": "Active Project",
            "project_paused": "Project Paused",
            "edit_notifications": "Edit Notifications",
            "select_employees": "Select Employees",
            "select_contacts": "Select Contacts",
            "revise_and_resubmit": "Revise And Resubmit",
            "for_record_only": "For Record Only",
            "make_corrections_as_noted": "Make Corrections As Noted",
            "mxn": "MXN",
            "usd": "USD",
            "to_quote": "To Quote",
            "to_quote_description": "Manage the projects to be quoted",
            "quoted": "Quoted",
            "quoted_description": "Manage quoted projects",
            "cancelled_description": "Manage cancelled projects",
            "in_order": "In Order",
            "in_orders": "In Orders",
            "rfi": "RFI",
            "rfis": "RFIs",
            "remision": "Remision",
            "in_order_description": "Manage in order projects",
            "edit_project": "Edit",
            "alert_employees_title": "Alert",
            "alert_employees_texts": "You don't have employees.",
            "english": "English",
            "spanish": "Spanish",
            "id": "Id",
            "mark": "Mark",
            "category_id": "Category id",
            "sequence": "Sequence",
            "description": "Description",
            "quantity": "Quantity",
            "scope": "Scope",
            "scopes": "Scopes",
            "project_id": "Project id",
            "image_logo": "Image logo",
            "download_a": "Download a",
            "sample_csv": "Sample CSV template",
            "example_file": "To see an example of the required format.",
            "created": "Created"
        },
        "submittals": {
            "add": "Agregar",
            "edit": "Edit Submittal",
            "see": "Submittal Details",
            "delete": "Delete Submittal",
            "not_find": "Can not find a Submittals with this code.",
            "id": "Id",
            "remission_number": "Remission Number",
            "remission_number_placeholder": "Enter the submittal's remission number",
            "starting_date": "Sending Date",
            "starting_date_placeholder": "Enter the submittal's sending date",
            "end_date": "Reply Date",
            "end_date_placeholder": "Enter the submittal's reply date",
            "submittal_number": "Submittal Number",
            "submittal_number_placeholder": "Enter the submittal's number",
            "status": "Status",
            "status_placeholder": "Enter the submittal's status",
            "created_by": "Created by",
            "created_by_placeholder": "Enter this submittal's creator",
            "approved": "Approved",
            "approved_placeholder": "Enter the submittal's approved",
            "package_name": "Package name",
            "package_name_placeholder": "Enter the submittal's package name",
            "type": "Type",
            "type_placeholder": "Enter the submittal's type",
            "comments": "Comments",
            "comments_placeholder": "Enter the submittal's comments",
            "filename": "File name",
            "filename_placeholder": "Enter the submittal's file name",
            "date": "Date",
            "date_placeholder": "Enter the submittal's date",
            "approve": "approved",
            "hold": "On hold",
            "assigned": "Assigned",
            "no_assigned": "No assigned",
            "cancelled": "Cancelled",
            "see_attachment": "See Attachment",
            "created_at": "Created at",
            "approved_date": "Approved at",
            "report_title": "Project Report"
        },
        "users": {
            "add": "Add user",
            "edit": "Edit user",
            "delete": "Delete user",
            "not_find": "Can not find user with this code.",
            "actived_error": "User is already active",
            "inactived_error": "User is already inactive",
            "actived": "User has been activated",
            "inactived": "User has been inactivated",
            "active": "Active",
            "inactive": "Inactive",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the user's name",
            "email": "Email",
            "email_placeholder": "Enter the user's email",
            "password": "Password",
            "password_placeholder": "Enter the user's password",
            "confirm_password": "Confirm Password",
            "confirm_password_placeholder": "Enter the user's confirm password",
            "role": "Role",
            "role_placeholder": "Enter the user's role",
            "status": "Status",
            "leave_empty": "Leave empty to keep the current password",
            "leave_empty_file": "Leave empty to keep the current file",
            "logo_file": "Logo file",
            "edit_customer": "Edit customer",
            "created_at": "Created at",
            "report_title": "Users Report"
        },
        "validation": {
            "accepted": "The :attribute must be accepted.",
            "accepted_if": "The :attribute must be accepted when :other is :value.",
            "active_url": "The :attribute is not a valid URL.",
            "after": "The :attribute must be a date after :date.",
            "after_or_equal": "The :attribute must be a date after or equal to :date.",
            "alpha": "The :attribute must only contain letters.",
            "alpha_dash": "The :attribute must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The :attribute must only contain letters and numbers.",
            "array": "The :attribute must be an array.",
            "before": "The :attribute must be a date before :date.",
            "before_or_equal": "The :attribute must be a date before or equal to :date.",
            "between": {
                "numeric": "The :attribute must be between :min and :max.",
                "file": "The :attribute must be between :min and :max kilobytes.",
                "string": "The :attribute must be between :min and :max characters.",
                "array": "The :attribute must have between :min and :max items."
            },
            "boolean": "The :attribute field must be true or false.",
            "confirmed": "The :attribute confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The :attribute is not a valid date.",
            "date_equals": "The :attribute must be a date equal to :date.",
            "date_format": "The :attribute does not match the format :format.",
            "declined": "The :attribute must be declined.",
            "declined_if": "The :attribute must be declined when :other is :value.",
            "different": "The :attribute and :other must be different.",
            "digits": "The :attribute must be :digits digits.",
            "digits_between": "The :attribute must be between :min and :max digits.",
            "dimensions": "The :attribute has invalid image dimensions.",
            "distinct": "The :attribute field has a duplicate value.",
            "email": "The :attribute must be a valid email address.",
            "ends_with": "The :attribute must end with one of the following: :values.",
            "enum": "The selected :attribute is invalid.",
            "exists": "The selected :attribute is invalid.",
            "file": "The :attribute must be a file.",
            "filled": "The :attribute field must have a value.",
            "gt": {
                "numeric": "The :attribute must be greater than :value.",
                "file": "The :attribute must be greater than :value kilobytes.",
                "string": "The :attribute must be greater than :value characters.",
                "array": "The :attribute must have more than :value items."
            },
            "gte": {
                "numeric": "The :attribute must be greater than or equal to :value.",
                "file": "The :attribute must be greater than or equal to :value kilobytes.",
                "string": "The :attribute must be greater than or equal to :value characters.",
                "array": "The :attribute must have :value items or more."
            },
            "image": "The :attribute must be an image.",
            "in": "The selected :attribute is invalid.",
            "in_array": "The :attribute field does not exist in :other.",
            "integer": "The :attribute must be an integer.",
            "ip": "The :attribute must be a valid IP address.",
            "ipv4": "The :attribute must be a valid IPv4 address.",
            "ipv6": "The :attribute must be a valid IPv6 address.",
            "json": "The :attribute must be a valid JSON string.",
            "lt": {
                "numeric": "The :attribute must be less than :value.",
                "file": "The :attribute must be less than :value kilobytes.",
                "string": "The :attribute must be less than :value characters.",
                "array": "The :attribute must have less than :value items."
            },
            "lte": {
                "numeric": "The :attribute must be less than or equal to :value.",
                "file": "The :attribute must be less than or equal to :value kilobytes.",
                "string": "The :attribute must be less than or equal to :value characters.",
                "array": "The :attribute must not have more than :value items."
            },
            "mac_address": "The :attribute must be a valid MAC address.",
            "max": {
                "numeric": "The :attribute must not be greater than :max.",
                "file": "The :attribute must not be greater than :max kilobytes.",
                "string": "The :attribute must not be greater than :max characters.",
                "array": "The :attribute must not have more than :max items."
            },
            "mimes": "The :attribute must be a file of type: :values.",
            "mimetypes": "The :attribute must be a file of type: :values.",
            "min": {
                "numeric": "The :attribute must be at least :min.",
                "file": "The :attribute must be at least :min kilobytes.",
                "string": "The :attribute must be at least :min characters.",
                "array": "The :attribute must have at least :min items."
            },
            "multiple_of": "The :attribute must be a multiple of :value.",
            "not_in": "The selected :attribute is invalid.",
            "not_regex": "The :attribute format is invalid.",
            "numeric": "The :attribute must be a number.",
            "password": "The password is incorrect.",
            "present": "The :attribute field must be present.",
            "prohibited": "The :attribute field is prohibited.",
            "prohibited_if": "The :attribute field is prohibited when :other is :value.",
            "prohibited_unless": "The :attribute field is prohibited unless :other is in :values.",
            "prohibits": "The :attribute field prohibits :other from being present.",
            "regex": "The :attribute format is invalid.",
            "required": "The :attribute field is required.",
            "required_array_keys": "The :attribute field must contain entries for: :values.",
            "required_if": "The :attribute field is required when :other is :value.",
            "required_unless": "The :attribute field is required unless :other is in :values.",
            "required_with": "The :attribute field is required when :values is present.",
            "required_with_all": "The :attribute field is required when :values are present.",
            "required_without": "The :attribute field is required when :values is not present.",
            "required_without_all": "The :attribute field is required when none of :values are present.",
            "same": "The :attribute and :other must match.",
            "size": {
                "numeric": "The :attribute must be :size.",
                "file": "The :attribute must be :size kilobytes.",
                "string": "The :attribute must be :size characters.",
                "array": "The :attribute must contain :size items."
            },
            "starts_with": "The :attribute must start with one of the following: :values.",
            "string": "The :attribute must be a string.",
            "timezone": "The :attribute must be a valid timezone.",
            "unique": "The :attribute has already been taken.",
            "uploaded": "The :attribute failed to upload.",
            "url": "The :attribute must be a valid URL.",
            "uuid": "The :attribute must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verify your Email Address",
            "check_email": "Check the inbox to finish the registration.",
            "check_email_label": "Check the email to finish the registration. We have sent you a registration link to the address:",
            "resend_email": "You have not received the registration link? Resend",
            "resend_succesfully": "Successfully resend",
            "reset_email": "Change email address"
        },
        "welcome": {
            "subject": "Welcome to Controlla",
            "line_1": "Welcome to controlla.",
            "action": "Start now"
        }
    }
};